import api from "../BrandOnBoarding/api";

export async function fetchAllCustomers() {
  const res = await api.get("/customers");
  return res.data?.data || [];
}

export async function fetchConversationMonitoringConfigs(customerId, includeInactive = false) {
  const params = new URLSearchParams({ customer_id: customerId });
  if (includeInactive) params.set("include_inactive", "true");
  const res = await api.get(`/conversation-monitoring?${params.toString()}`);
  return res.data?.data || [];
}

export async function createConversationMonitoringConfig(payload) {
  const res = await api.post("/conversation-monitoring", payload);
  return res.data?.data;
}

export async function updateConversationMonitoringConfig(id, payload) {
  const res = await api.put(`/conversation-monitoring/${id}`, payload);
  return res.data?.data;
}

export async function deleteConversationMonitoringConfig(id, customerId) {
  const res = await api.delete(`/conversation-monitoring/${id}?customer_id=${customerId}`);
  return res.data?.data;
}
